<p-sidebar
  [(visible)]="visible"
  position="right"
  styleClass="w-screen lg:w-4"
  appendTo="body"
>
  <ng-template pTemplate="header"> </ng-template>
  <ng-template pTemplate="content">
    <div class="field mb-4">
      <span class="text-900 text-2xl block font-bold mb-5"
        >Comprar como invitado</span
      >
    </div>
    <p class="text-700 font-normal text-base mb-5">
      Con tu registro, accedes a la información de tus compras y obtienes
      múltiples beneficios.
    </p>

    <p-button
      (click)="goToCheckout()"
      label="Continuar como invitado"
      class="w-full"
      styleClass="w-full"
    />

    <p-divider class="w-full px-2 mb-3" />
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <div class="field mb-4">
        <span class="text-900 text-2xl block font-bold mb-5"
          >Inicia sesión en tu cuenta</span
        >
      </div>

      <!-- Start::input email -->
      <div class="field mb-4 flex flex-column">
        <label for="email" class="font-semibold text-900"
          >Correo eletrónico</label
        >
        <app-email-input formControlName="email" />
      </div>
      <!-- End::input email -->

      <!-- Start::input contraseña -->
      <div class="field mb-4 flex flex-column">
        <label for="password" class="font-semibold text-900">Contraseña</label>
        <p-password
          formControlName="password"
          [toggleMask]="true"
          [feedback]="false"
        />
      </div>

      <div class="flex align-items-center justify-content-end mb-5">
        <a
          href="sitio/recover"
          class="font-medium text-blue-500 hover:text-blue-700 cursor-pointer transition-colors transition-duration-150 underline"
          >Olvidé mi contraseña</a
        >
      </div>

      <!--
      <p-button
        (click)="login()"
        label="Iniciar sesión"
        class="w-full"
        styleClass="w-full"
        type="submit"
      />-->
      <p-button
        (click)="login()"
        [label]="isLoading() ? '' : 'Iniciar sesión'"
        class="w-full"
        styleClass="w-full"
        type="submit"
        [disabled]="isLoading()"
      >
        <ng-template pTemplate="icon">
          @if(isLoading()){
          <i class="fa-duotone fa-solid fa-loader fa-spin-pulse fa-xl"></i>
          }
        </ng-template>
      </p-button>

      <div class="mt-4 text-700 font-normal text-base text-center">
        ¿Eres nuevo en Implementos?

        <div>
          <a
            (click)="goToRegister()"
            class="font-medium text-blue-500 no-underline hover:text-blue-700 hover:underline cursor-pointer"
            >Crear cuenta</a
          >
        </div>
      </div>
    </form>
  </ng-template>
</p-sidebar>

<!-- Start::toast de error o éxito -->
<p-toast />
<!-- End::toast de error o éxito -->
